import { Brain, BotMessageSquare, FileText } from "lucide-react";

import { Button } from "../../components/ui/button";
import SectionHeading from "../../components/common/SectionHeading";


import assistantImg from "../../components/image/assets/ai-assistant.svg";

const items = [
  {
    icon: Brain,
    title: "Smart suggestions",
    description: "AI scans your project specs and delivers optimized pricing—tailored to crush bids and win jobs fast."
  },
  {
    icon: BotMessageSquare,
    title: "Hybrid approach",
    description: "Fuse our proprietary engine with AI smarts for recommendations that blend precision and innovation like no other tool."
  },
  {
    icon: FileText,
    title: "Ready-to-Send PDFs",
    description: "Whip up pro estimates in seconds and email them instantly—sealing deals without the hassle."
  }
];

export default function SmartAISection() {
  return (
    <section className="bg-page-accent-soft section-padding">
      <div className="container-safe">
        <SectionHeading
          title="Instant AI Estimates: Accurate & Market-Smart"
          description="Industry-First AI Estimates in Seconds: That Simplify Workflows and Skyrocket Efficiency."
        />
        {/* Content: List + Image */}
        <div className="xs:mt-10 mt-6 grid grid-cols-1 items-center justify-center gap-8 md:mt-14 md:grid-cols-2 lg:mr-12">
          <ul className="xs:space-y-6 max-w-[385px] space-y-3 justify-self-center lg:justify-self-end">
            {items.map(({ icon: Icon, title, description }) => (
              <li
                key={title}
                className="shadow-card hover:shadow-card-hover bg-background rounded-2xl p-4"
              >
                <div className="flex items-start gap-3">
                  <div className="bg-blue-soft grid size-20 shrink-0 place-items-center rounded-full">
                    <Icon className="text-primary size-8" />
                  </div>
                  <div>
                    <h3 className="xs:text-xl xs:leading-7 text-lg leading-4 font-medium">
                      {title}
                    </h3>
                    <p className="text-paragraph xs:leading-7 mt-2 leading-4">{description}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          {/* Image */}
          <div className="justify-self-start max-md:hidden">
            <img
              src={assistantImg}
              alt="AI assistant generating estimate on a laptop"
              className="h-[340px] w-auto"
            />
          </div>
        </div>

{/** 
        <div className="xs:mt-10 mt-6 flex justify-center md:mt-14">
          <Button size="wider">
            <a
              href="https://mrjoe.pro/login"
              target="_blank"
              rel="noopener noreferrer"
            >
              Try It Now
            </a>
          </Button>
        </div>

*/}
      </div>
    </section>
  );
}
